import { render, staticRenderFns } from "./RecuperarPassword.vue?vue&type=template&id=4cfae726&scoped=true"
import script from "./RecuperarPassword.vue?vue&type=script&lang=ts"
export * from "./RecuperarPassword.vue?vue&type=script&lang=ts"
import style0 from "./RecuperarPassword.vue?vue&type=style&index=0&id=4cfae726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfae726",
  null
  
)

export default component.exports